(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theprimecatch-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFooter = (footer) => {
      if (!footer || footer.dataset.primeFooterReady === 'true') return;
      footer.dataset.primeFooterReady = 'true';

      const groups = Array.from(footer.querySelectorAll('[data-prime-footer-group]'));
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const setResponsiveState = () => {
        groups.forEach((group) => {
          const panel = group.querySelector('[data-prime-footer-panel]');
          if (!panel) return;

          if (mobileQuery.matches) {
            group.open = false;
            panel.style.height = '0px';
            panel.style.opacity = '0';
          } else {
            group.open = true;
            panel.style.height = 'auto';
            panel.style.opacity = '1';
          }
        });
      };

      const openGroup = (group, panel) => {
        group.open = true;
        if (reducedMotion.matches) {
          panel.style.height = 'auto';
          panel.style.opacity = '1';
          return;
        }

        panel.style.height = '0px';
        panel.style.opacity = '0';
        const targetHeight = panel.scrollHeight;
        requestAnimationFrame(() => {
          panel.style.height = `${targetHeight}px`;
          panel.style.opacity = '1';
        });

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onEnd);
        };
        panel.addEventListener('transitionend', onEnd);
      };

      const closeGroup = (group, panel) => {
        if (reducedMotion.matches) {
          group.open = false;
          panel.style.height = '0px';
          panel.style.opacity = '0';
          return;
        }

        panel.style.height = `${panel.scrollHeight}px`;
        panel.style.opacity = '1';
        requestAnimationFrame(() => {
          panel.style.height = '0px';
          panel.style.opacity = '0';
        });

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          group.open = false;
          panel.removeEventListener('transitionend', onEnd);
        };
        panel.addEventListener('transitionend', onEnd);
      };

      groups.forEach((group) => {
        const summary = group.querySelector('summary');
        const panel = group.querySelector('[data-prime-footer-panel]');
        if (!summary || !panel) return;

        summary.addEventListener('click', (event) => {
          if (!mobileQuery.matches) return;
          event.preventDefault();
          if (group.open) closeGroup(group, panel);
          else openGroup(group, panel);
        });
      });

      setResponsiveState();
      mobileQuery.addEventListener('change', setResponsiveState);
    };

    const boot = (root = document) => {
      if (root.matches?.('[data-prime-footer]')) initFooter(root);
      root.querySelectorAll?.('[data-prime-footer]').forEach(initFooter);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theprimecatch-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function initHeader(root) {
    if (!root || root.dataset.pcReady === 'true') return;
    root.dataset.pcReady = 'true';

    var abort = new AbortController();
    root._pcAbort = abort;
    var signal = abort.signal;

    var routesRoot = root.dataset.rootUrl || '/';
    if (!routesRoot.endsWith('/')) routesRoot += '/';

    var currency = root.dataset.currency || 'USD';
    var designMode = root.dataset.designMode === 'true';
    var shippingCost = Number(root.dataset.shippingCost || 400);
    var freeShippingQuantity = Math.max(1, Number(root.dataset.freeShippingQuantity || 2));
    var mainProductId = String(root.dataset.mainProductId || '');
    var mainVariantId = Number(root.dataset.mainVariantId || 0);
    var mainProductTitle = root.dataset.mainProductTitle || 'ShowerDock';
    var buyThreeSavings = Number(root.dataset.buyThreeSavings || 600);
    var enableBuyTwoUpsell = root.dataset.enableBuyTwoUpsell === 'true';
    var enableBuyThreeUpsell = root.dataset.enableBuyThreeUpsell === 'true';
    var autoUpsellLimit = Math.max(0, Number(root.dataset.autoUpsellLimit || 0));
    var spacer = root.nextElementSibling && root.nextElementSibling.matches('[data-pc-header-spacer]')
      ? root.nextElementSibling
      : null;

    function updateHeaderHeight() {
      var height = Math.ceil(root.getBoundingClientRect().height || 0);
      if (spacer) spacer.style.height = height + 'px';
      document.documentElement.style.setProperty('--pc-header-height', height + 'px');
    }

    var overlay = root.querySelector('[data-pc-overlay]');
    var menuDrawer = root.querySelector('[data-pc-menu-drawer]');
    var cartDrawer = root.querySelector('[data-pc-cart-drawer]');
    var search = root.querySelector('[data-pc-search]');
    var searchInput = root.querySelector('[data-pc-search-input]');
    var menuOpen = root.querySelector('[data-pc-menu-open]');
    var cartOpen = root.querySelector('[data-pc-cart-open]');
    var cartCount = root.querySelector('[data-pc-cart-count]');
    var cartCountLabel = root.querySelector('[data-pc-cart-count-label]');
    var cartItems = root.querySelector('[data-pc-cart-items]');
    var cartEmpty = root.querySelector('[data-pc-cart-empty]');
    var emptyAddButton = root.querySelector('[data-pc-empty-add]');
    var emptyAddError = root.querySelector('[data-pc-empty-add-error]');
    var subtotalNode = root.querySelector('[data-pc-subtotal]');
    var shippingNode = root.querySelector('[data-pc-shipping]');
    var totalNode = root.querySelector('[data-pc-total]');
    var checkout = root.querySelector('[data-pc-checkout]');
    var cartOffer = root.querySelector('[data-pc-cart-offer]');
    var cartOfferTime = root.querySelector('[data-pc-cart-offer-time]');
    var cartOfferCopy = root.querySelector('[data-pc-cart-offer-copy]');
    var progressWrap = root.querySelector('[data-pc-progress-wrap]');
    var progressTitle = root.querySelector('[data-pc-progress-title]');
    var progressMessage = root.querySelector('[data-pc-progress-message]');
    var progressPercent = root.querySelector('[data-pc-progress-percent]');
    var progressFill = root.querySelector('[data-pc-progress-fill]');
    var upgrade = root.querySelector('[data-pc-upgrade]');
    var upgradeTitle = root.querySelector('[data-pc-upgrade-title]');
    var upgradeText = root.querySelector('[data-pc-upgrade-text]');
    var upgradeButton = root.querySelector('[data-pc-upgrade-add]');
    var upgradeButtonText = root.querySelector('[data-pc-upgrade-button]');
    var upsells = root.querySelector('[data-pc-upsells]');
    var upsellTrack = root.querySelector('[data-pc-upsell-track]');
    var upsellPrev = root.querySelector('[data-pc-upsell-prev]');
    var upsellNext = root.querySelector('[data-pc-upsell-next]');

    var currentCart = null;
    var returnFocus = null;
    var autoUpsellAnchor = '';
    var cartRefreshPromise = null;
    var pausedAutoplayVideos = [];

    // The cart timer mirrors the builder's session-stored two-minute promotional window.
    function getReservedDiscount() {
      try {
        var stored = window.sessionStorage.getItem('primecatch:reserved-discount:v1');
        if (stored) return JSON.parse(stored);
      } catch (error) {}
      return window.PrimeCatchReservedDiscount || null;
    }
    function renderCartOffer() {
      if (!cartOffer) return;
      var offer = getReservedDiscount();
      var remaining = offer && offer.code && Number.isFinite(Number(offer.endsAt)) ? Math.max(0, Number(offer.endsAt) - Date.now()) : 0;
      if (remaining <= 0) {
        cartOffer.hidden = true;
        cartOffer.classList.remove('is-urgent');
        return;
      }
      cartOffer.hidden = false;
      var seconds = Math.ceil(remaining / 1000);
      if (cartOfferTime) cartOfferTime.textContent = Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
      cartOffer.classList.toggle('is-urgent', seconds <= 30);
      if (cartOfferCopy && cartOfferCopy.dataset.copiedCode !== offer.code) {
        cartOfferCopy.textContent = 'COPY CODE';
        cartOfferCopy.dataset.copiedCode = '';
      }
    }
    if (cartOffer) {
      renderCartOffer();
      document.addEventListener('primecatch:discount-offer-changed', renderCartOffer, { signal: signal });
      var cartOfferInterval = window.setInterval(renderCartOffer, 1000);
      signal.addEventListener('abort', function () { window.clearInterval(cartOfferInterval); }, { once: true });
    }
    if (cartOfferCopy) {
      cartOfferCopy.addEventListener('click', async function () {
        var offer = getReservedDiscount();
        if (!offer || !offer.code || Number(offer.endsAt) <= Date.now()) return;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(offer.code);
          } else {
            var temp = document.createElement('textarea');
            temp.value = offer.code;
            temp.setAttribute('readonly', '');
            temp.style.position = 'fixed'; temp.style.opacity = '0';
            document.body.appendChild(temp); temp.select();
            var copied = document.execCommand('copy'); temp.remove();
            if (!copied) throw new Error('Copy failed');
          }
          cartOfferCopy.textContent = 'COPIED';
          cartOfferCopy.dataset.copiedCode = offer.code;
        } catch (error) {
          cartOfferCopy.textContent = 'TRY AGAIN';
        }
      }, { signal: signal });
    }

    function activePanel() {
      if (cartDrawer && cartDrawer.classList.contains('is-active')) return cartDrawer;
      if (menuDrawer && menuDrawer.classList.contains('is-active')) return menuDrawer;
      if (search && search.classList.contains('is-active')) return search;
      return null;
    }

    function pauseBackgroundMedia() {
      pausedAutoplayVideos = [];
      document.querySelectorAll('video[autoplay]').forEach(function (video) {
        if (!video.paused) {
          pausedAutoplayVideos.push(video);
          try { video.pause(); } catch (error) {}
        }
      });
    }

    function resumeBackgroundMedia() {
      pausedAutoplayVideos.forEach(function (video) {
        if (!document.contains(video)) return;
        try {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        } catch (error) {}
      });
      pausedAutoplayVideos = [];
    }

    function lockBody() {
      root.classList.add('is-panel-open');
      if (!designMode) document.body.classList.add('pc-panel-open');
      pauseBackgroundMedia();
    }

    function unlockBody() {
      if (!activePanel()) {
        root.classList.remove('is-panel-open');
        document.body.classList.remove('pc-panel-open');
        resumeBackgroundMedia();
      }
    }

    function closeAll(restoreFocus) {
      if (menuDrawer) {
        menuDrawer.classList.remove('is-active');
        menuDrawer.setAttribute('aria-hidden', 'true');
      }
      if (cartDrawer) {
        cartDrawer.classList.remove('is-active');
        cartDrawer.setAttribute('aria-hidden', 'true');
      }
      if (search) {
        search.classList.remove('is-active');
        search.setAttribute('aria-hidden', 'true');
      }
      if (overlay) overlay.classList.remove('is-active');
      if (menuOpen) menuOpen.setAttribute('aria-expanded', 'false');
      if (cartOpen) cartOpen.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-panel-open');
      document.body.classList.remove('pc-panel-open');
      resumeBackgroundMedia();
      if (restoreFocus !== false && returnFocus && typeof returnFocus.focus === 'function') {
        returnFocus.focus();
      }
      returnFocus = null;
    }

    function openMenu(trigger) {
      closeAll(false);
      returnFocus = trigger || document.activeElement;
      if (menuDrawer) {
        menuDrawer.classList.add('is-active');
        menuDrawer.setAttribute('aria-hidden', 'false');
      }
      if (menuOpen) menuOpen.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-active');
      lockBody();
      window.setTimeout(function () {
        var close = root.querySelector('[data-pc-menu-close]');
        if (close) close.focus();
      }, 80);
    }

    function openCart(trigger, skipRefresh) {
      renderCartOffer();
      returnFocus = trigger || document.activeElement;
      if (menuDrawer) {
        menuDrawer.classList.remove('is-active');
        menuDrawer.setAttribute('aria-hidden', 'true');
      }
      if (search) {
        search.classList.remove('is-active');
        search.setAttribute('aria-hidden', 'true');
      }
      if (menuOpen) menuOpen.setAttribute('aria-expanded', 'false');
      if (cartDrawer) {
        cartDrawer.classList.add('is-active');
        cartDrawer.setAttribute('aria-hidden', 'false');
      }
      if (cartOpen) cartOpen.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-active');
      lockBody();
      if (!skipRefresh) refreshCart();
      window.setTimeout(function () {
        var close = root.querySelector('[data-pc-cart-close]');
        if (close) close.focus();
      }, 120);
    }

    function openSearch(trigger) {
      closeAll(false);
      returnFocus = trigger || document.activeElement;
      if (search) {
        search.classList.add('is-active');
        search.setAttribute('aria-hidden', 'false');
      }
      lockBody();
      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 90);
    }

    async function requestCart() {
      var response = await fetch(routesRoot + 'cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Unable to load cart.');
      return response.json();
    }

    function mainProductQuantity(cart) {
      if (!cart || !Array.isArray(cart.items) || !mainProductId) return 0;
      return cart.items.reduce(function (sum, item) {
        return String(item.product_id) === mainProductId ? sum + Number(item.quantity || 0) : sum;
      }, 0);
    }

    function renderCartItems(cart) {
      if (!cartItems || !cartEmpty) return;
      var items = Array.isArray(cart.items) ? cart.items : [];
      if (!items.length) {
        cartItems.innerHTML = '';
        cartItems.hidden = true;
        cartEmpty.hidden = false;
        return;
      }

      cartItems.hidden = false;
      cartEmpty.hidden = true;
      cartItems.innerHTML = items.map(function (item) {
        var image = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
          : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<small>' + escapeHtml(item.variant_title) + '</small>'
          : '';
        return '<article class="pc-cart-item" data-key="' + escapeHtml(item.key) + '">' +
          '<div class="pc-cart-item__image">' + image + '</div>' +
          '<div class="pc-cart-item__copy">' +
            '<strong>' + escapeHtml(item.product_title) + '</strong>' +
            variant +
            '<div class="pc-cart-item__price">' + money(item.final_line_price, currency) + '</div>' +
            '<div class="pc-cart-item__quantity" aria-label="Quantity controls">' +
              '<button type="button" data-pc-decrease aria-label="Decrease quantity">−</button>' +
              '<span>' + Number(item.quantity || 0) + '</span>' +
              '<button type="button" data-pc-increase aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="pc-cart-item__remove" type="button" data-pc-remove aria-label="Remove ' + escapeHtml(item.product_title) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"/></svg>' +
          '</button>' +
        '</article>';
      }).join('');
    }

    function updateProgress(cart) {
      var quantity = mainProductQuantity(cart);
      var unlocked = quantity >= freeShippingQuantity;
      var progress = Math.min(100, Math.max(0, (quantity / freeShippingQuantity) * 100));
      var remaining = Math.max(0, freeShippingQuantity - quantity);

      if (progressWrap) progressWrap.classList.toggle('is-unlocked', unlocked);
      if (progressFill) progressFill.style.width = progress + '%';
      if (progressPercent) progressPercent.textContent = Math.round(progress) + '%';

      if (progressTitle) {
        progressTitle.textContent = unlocked ? 'Free delivery unlocked' : 'Unlock free delivery';
      }
      if (progressMessage) {
        if (unlocked) {
          progressMessage.textContent = 'Your order qualifies for free delivery across Lebanon.';
        } else if (quantity === 0) {
          progressMessage.textContent = 'Add ' + mainProductTitle + ' to start your order.';
        } else {
          progressMessage.textContent = 'Add ' + remaining + ' more ' + mainProductTitle + ' to unlock free delivery.';
        }
      }
    }

    function updateUpgrade(cart) {
      if (!upgrade || !upgradeButton) return;
      var quantity = mainProductQuantity(cart);
      // Allow merchants to enable or disable each cart quantity upgrade independently.
      var show = Boolean(mainVariantId && ((quantity === 1 && enableBuyTwoUpsell) || (quantity === 2 && enableBuyThreeUpsell)));
      upgrade.hidden = !show;
      if (!show) return;

      if (quantity === 1) {
        if (upgradeTitle) upgradeTitle.textContent = 'Add one more and get free delivery';
        if (upgradeText) upgradeText.textContent = 'Turn your order into the Buy 2 offer and save the delivery fee.';
        if (upgradeButtonText) upgradeButtonText.textContent = 'ADD SECOND ONE';
      } else {
        if (upgradeTitle) upgradeTitle.textContent = 'Complete the Buy 3 offer';
        if (upgradeText) upgradeText.textContent = buyThreeSavings > 0
          ? 'Add one more and unlock ' + money(buyThreeSavings, currency) + ' in Buy 3 savings at checkout.'
          : 'Add one more and unlock the Buy 3 offer.';
        if (upgradeButtonText) upgradeButtonText.textContent = 'Add Third One';
      }
    }

    function updateSummary(cart) {
      var subtotal = Number(cart.total_price || 0);
      var quantity = mainProductQuantity(cart);
      var freeDelivery = quantity >= freeShippingQuantity;
      var shipping = cart.item_count > 0 && !freeDelivery ? shippingCost : 0;
      var total = subtotal + shipping;

      if (subtotalNode) subtotalNode.textContent = money(subtotal, currency);
      if (shippingNode) shippingNode.textContent = cart.item_count === 0 ? money(0, currency) : (freeDelivery ? 'FREE' : money(shipping, currency));
      if (totalNode) totalNode.textContent = money(total, currency);
      if (checkout) checkout.disabled = Number(cart.item_count || 0) === 0;
    }

    function updateHeader(cart) {
      var count = Number(cart.item_count || 0);
      if (cartCount) cartCount.textContent = String(count);
      if (cartCountLabel) cartCountLabel.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
    }

    function hideCartProductsFromUpsells(cart) {
      if (!upsellTrack) return;
      var ids = new Set((cart.items || []).map(function (item) { return String(item.product_id); }));
      var visible = 0;
      root.querySelectorAll('[data-pc-upsell-card]').forEach(function (card) {
        var hide = ids.has(String(card.dataset.productId || ''));
        card.hidden = hide;
        if (!hide) visible += 1;
      });
      if (upsells) upsells.hidden = visible === 0;
    }

    function removeAutoUpsells() {
      if (!upsellTrack) return;
      upsellTrack.querySelectorAll('[data-source="auto"]').forEach(function (card) { card.remove(); });
    }

    function buildAutoUpsell(product) {
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return '';
      var variant = product.variants.find(function (item) { return item.available; }) || product.variants[0];
      if (!variant) return '';
      var image = product.featured_image
        ? '<img src="' + escapeHtml(product.featured_image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
        : '';
      var control = product.variants.length > 1
        ? '<select data-pc-upsell-variant aria-label="Choose option for ' + escapeHtml(product.title) + '">' + product.variants.map(function (item) {
            return '<option value="' + item.id + '" data-price="' + item.price + '" ' + (!item.available ? 'disabled' : '') + ' ' + (item.id === variant.id ? 'selected' : '') + '>' + escapeHtml(item.title) + (!item.available ? ' Sold out' : '') + '</option>';
          }).join('') + '</select>'
        : '<input type="hidden" value="' + variant.id + '" data-pc-upsell-variant>';

      return '<article class="pc-upsell-card" data-pc-upsell-card data-source="auto" data-product-id="' + product.id + '">' +
        '<a class="pc-upsell-card__image" href="' + escapeHtml(product.url || '#') + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
        '<div class="pc-upsell-card__content">' +
          '<a href="' + escapeHtml(product.url || '#') + '">' + escapeHtml(product.title) + '</a>' +
          control +
          '<div><strong data-pc-upsell-price>' + money(variant.price, currency) + '</strong><button type="button" data-pc-upsell-add>Add</button></div>' +
        '</div>' +
      '</article>';
    }

    async function loadAutomaticUpsells(cart) {
      if (!upsellTrack || autoUpsellLimit <= 0 || !cart || !Array.isArray(cart.items) || !cart.items.length) {
        removeAutoUpsells();
        autoUpsellAnchor = '';
        return;
      }

      var anchorId = String(cart.items[0].product_id || '');
      if (!anchorId || anchorId === autoUpsellAnchor) return;
      autoUpsellAnchor = anchorId;
      removeAutoUpsells();

      try {
        var response = await fetch(routesRoot + 'recommendations/products.json?product_id=' + encodeURIComponent(anchorId) + '&limit=' + autoUpsellLimit + '&intent=related', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) return;
        var data = await response.json();
        var products = Array.isArray(data.products) ? data.products : [];
        var ids = new Set((cart.items || []).map(function (item) { return String(item.product_id); }));
        products.forEach(function (product) {
          if (!product || ids.has(String(product.id))) return;
          var html = buildAutoUpsell(product);
          if (html) upsellTrack.insertAdjacentHTML('beforeend', html);
        });
      } catch (error) {
        autoUpsellAnchor = '';
      }
    }

    function refreshCart() {
      if (cartRefreshPromise) return cartRefreshPromise;

      cartRefreshPromise = requestCart().then(function (cart) {
        currentCart = cart;
        updateHeader(currentCart);
        renderCartItems(currentCart);
        updateProgress(currentCart);
        updateUpgrade(currentCart);
        updateSummary(currentCart);
        hideCartProductsFromUpsells(currentCart);
        document.dispatchEvent(new CustomEvent('primecatch:cart-refreshed', { detail: currentCart }));

        loadAutomaticUpsells(currentCart).then(function () {
          hideCartProductsFromUpsells(currentCart);
        }).catch(function () {});

        return currentCart;
      }).catch(function () {
        return null;
      }).finally(function () {
        cartRefreshPromise = null;
      });

      return cartRefreshPromise;
    }

    async function addVariant(variantId, quantity, properties) {
      var id = Number(variantId || 0);
      if (!id) throw new Error('Missing variant ID.');
      var response = await fetch(routesRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: id, quantity: Math.max(1, Number(quantity || 1)), properties: properties || {} }]
        })
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
      await refreshCart();
      return data;
    }

    async function changeLine(key, quantity) {
      var response = await fetch(routesRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity || 0)) })
      });
      if (!response.ok) throw new Error('Unable to update cart.');
      currentCart = await response.json();
      updateHeader(currentCart);
      renderCartItems(currentCart);
      updateProgress(currentCart);
      updateUpgrade(currentCart);
      updateSummary(currentCart);
      await loadAutomaticUpsells(currentCart);
      hideCartProductsFromUpsells(currentCart);
      document.dispatchEvent(new CustomEvent('primecatch:cart-refreshed', { detail: currentCart }));
      return currentCart;
    }

    if (menuOpen) menuOpen.addEventListener('click', function () { openMenu(menuOpen); }, { signal: signal });
    var menuClose = root.querySelector('[data-pc-menu-close]');
    if (menuClose) menuClose.addEventListener('click', function () { closeAll(); }, { signal: signal });
    if (cartOpen) cartOpen.addEventListener('click', function () { openCart(cartOpen); }, { signal: signal });
    var cartClose = root.querySelector('[data-pc-cart-close]');
    if (cartClose) cartClose.addEventListener('click', function () { closeAll(); }, { signal: signal });
    var searchOpen = root.querySelector('[data-pc-search-open]');
    if (searchOpen) searchOpen.addEventListener('click', function () { openSearch(searchOpen); }, { signal: signal });
    var searchClose = root.querySelector('[data-pc-search-close]');
    if (searchClose) searchClose.addEventListener('click', function () { closeAll(); }, { signal: signal });
    if (overlay) overlay.addEventListener('click', function () { closeAll(); }, { signal: signal });
    if (search) search.addEventListener('click', function (event) { if (event.target === search) closeAll(); }, { signal: signal });

    root.querySelectorAll('.pc-mobile-nav a').forEach(function (link) {
      link.addEventListener('click', function () { closeAll(false); }, { signal: signal });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activePanel()) closeAll();
    }, { signal: signal });

    if (cartItems) {
      cartItems.addEventListener('click', async function (event) {
        var item = event.target.closest('.pc-cart-item');
        if (!item || !currentCart) return;
        var key = item.dataset.key || '';
        var cartItem = (currentCart.items || []).find(function (entry) { return entry.key === key; });
        if (!cartItem) return;
        try {
          if (event.target.closest('[data-pc-decrease]')) await changeLine(key, Number(cartItem.quantity || 0) - 1);
          if (event.target.closest('[data-pc-increase]')) await changeLine(key, Number(cartItem.quantity || 0) + 1);
          if (event.target.closest('[data-pc-remove]')) await changeLine(key, 0);
        } catch (error) {}
      }, { signal: signal });
    }

    if (emptyAddButton) {
      emptyAddButton.addEventListener('click', async function () {
        // Never add a duplicate when the cart is already populated or a request is running.
        if (emptyAddButton.disabled || (currentCart && Number(currentCart.item_count || 0) > 0)) return;
        var variantId = Number(emptyAddButton.dataset.variantId || mainVariantId || 0);
        if (!variantId) return;
        var originalLabel = emptyAddButton.textContent;
        emptyAddButton.disabled = true;
        emptyAddButton.textContent = 'ADDING...';
        if (emptyAddError) { emptyAddError.hidden = true; emptyAddError.textContent = ''; }
        try {
          await addVariant(variantId, 1, {});
        } catch (error) {
          if (emptyAddError) {
            emptyAddError.textContent = error && error.message ? error.message : 'Could not add this item. Please try again.';
            emptyAddError.hidden = false;
          }
        } finally {
          if (document.contains(emptyAddButton)) {
            emptyAddButton.disabled = false;
            emptyAddButton.textContent = originalLabel;
          }
        }
      }, { signal: signal });
    }

    if (upgradeButton) {
      upgradeButton.addEventListener('click', async function () {
        if (!mainVariantId || !currentCart) return;
        var quantity = mainProductQuantity(currentCart);
        if ((quantity === 1 && !enableBuyTwoUpsell) || (quantity === 2 && !enableBuyThreeUpsell) || (quantity !== 1 && quantity !== 2)) return;
        var old = upgradeButtonText ? upgradeButtonText.textContent : 'Add One More';
        upgradeButton.disabled = true;
        if (upgradeButtonText) upgradeButtonText.textContent = 'Adding';
        try {
          await addVariant(mainVariantId, 1, {});
          if (upgradeButtonText) upgradeButtonText.textContent = 'Added';
        } catch (error) {
          if (upgradeButtonText) upgradeButtonText.textContent = 'Try Again';
        }
        window.setTimeout(function () {
          if (!document.contains(upgradeButton)) return;
          upgradeButton.disabled = false;
          if (upgradeButtonText) upgradeButtonText.textContent = old;
        }, 900);
      }, { signal: signal });
    }

    root.addEventListener('change', function (event) {
      var select = event.target.closest('select[data-pc-upsell-variant]');
      if (!select) return;
      var card = select.closest('[data-pc-upsell-card]');
      var priceNode = card ? card.querySelector('[data-pc-upsell-price]') : null;
      var option = select.selectedOptions ? select.selectedOptions[0] : null;
      if (priceNode && option && option.dataset.price) priceNode.textContent = money(option.dataset.price, currency);
    }, { signal: signal });

    root.addEventListener('click', async function (event) {
      var add = event.target.closest('[data-pc-upsell-add]');
      if (!add) return;
      var card = add.closest('[data-pc-upsell-card]');
      var control = card ? card.querySelector('[data-pc-upsell-variant]') : null;
      var variantId = control ? control.value : '';
      if (!variantId) return;
      var old = add.textContent;
      add.disabled = true;
      add.textContent = 'Adding';
      try {
        await addVariant(variantId, 1, {});
        add.textContent = 'Added';
      } catch (error) {
        add.textContent = 'Try Again';
      }
      window.setTimeout(function () {
        if (!document.contains(add)) return;
        add.textContent = old;
        add.disabled = false;
      }, 900);
    }, { signal: signal });

    function scrollUpsells(direction) {
      if (!upsellTrack) return;
      var card = Array.from(upsellTrack.querySelectorAll('[data-pc-upsell-card]')).find(function (item) { return !item.hidden; });
      var step = card ? card.getBoundingClientRect().width + 8 : upsellTrack.clientWidth * .85;
      upsellTrack.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    if (upsellPrev) upsellPrev.addEventListener('click', function () { scrollUpsells(-1); }, { signal: signal });
    if (upsellNext) upsellNext.addEventListener('click', function () { scrollUpsells(1); }, { signal: signal });

    if (checkout) {
      checkout.addEventListener('click', function () {
        if (!currentCart || Number(currentCart.item_count || 0) === 0) return;
        window.location.href = routesRoot + 'checkout';
      }, { signal: signal });
    }

    document.addEventListener('cart:updated', refreshCart, { signal: signal });
    document.addEventListener('cart:refresh', refreshCart, { signal: signal });
    window.addEventListener('resize', updateHeaderHeight, { signal: signal, passive: true });

    if ('ResizeObserver' in window) {
      var headerResizeObserver = new ResizeObserver(updateHeaderHeight);
      headerResizeObserver.observe(root);
      signal.addEventListener('abort', function () { headerResizeObserver.disconnect(); }, { once: true });
    }

    window.PrimeCatchCart = {
      add: async function (variantId, quantity, properties) {
        var result = await addVariant(variantId, quantity, properties);
        openCart(null, true);
        return result;
      },
      refresh: refreshCart,
      open: openCart,
      close: closeAll
    };

    updateHeaderHeight();
    refreshCart();
  }

  function initAll(scope) {
    var parent = scope || document;
    if (parent.matches && parent.matches('[data-primecatch-header]')) initHeader(parent);
    if (parent.querySelectorAll) parent.querySelectorAll('[data-primecatch-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  if (!window.__pcHeaderLifecycleBound) {
    window.__pcHeaderLifecycleBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var target = event.target;
      var root = null;
      if (target && target.matches && target.matches('[data-primecatch-header]')) root = target;
      if (!root && target && target.querySelector) root = target.querySelector('[data-primecatch-header]');
      if (root && root._pcAbort) root._pcAbort.abort();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theprimecatch-product-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function parseConfig(root) {
    var node = root.querySelector('[data-pc-pb-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function initBuilder(root) {
    if (!root || root.dataset.pcPbReady === 'true') return;
    root.dataset.pcPbReady = 'true';

    var config = parseConfig(root);
    if (!config) return;

    var controller = new AbortController();
    var signal = controller.signal;
    root._pcPbController = controller;

    var variants = Array.isArray(config.variants) ? config.variants : [];
    var currentVariant = variants.find(function (variant) { return Number(variant.id) === Number(config.initialVariantId); }) || variants[0] || null;
    var selectedOptions = currentVariant ? currentVariant.options.slice() : [];
    var selectedQuantity = 1;
    var selectedPlan = '1';
    var activeSlide = 0;
    var timerActive = false;
    var discountCopied = false;
    var activeDiscountCode = '';

    var slides = Array.from(root.querySelectorAll('[data-pc-pb-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-pc-pb-thumb]'));
    var count = root.querySelector('[data-pc-pb-count]');
    var slidesWrap = root.querySelector('[data-pc-pb-slides]');
    var price = root.querySelector('[data-pc-pb-price]');
    var compare = root.querySelector('[data-pc-pb-compare]');
    var sale = root.querySelector('[data-pc-pb-sale]');
    var stock = root.querySelector('[data-pc-pb-stock]');
    var stockText = root.querySelector('[data-pc-pb-stock-text]');
    var form = root.querySelector('[data-pc-pb-form]');
    var formVariant = root.querySelector('[data-pc-pb-form-variant]');
    var formQuantity = root.querySelector('[data-pc-pb-form-quantity]');
    var add = root.querySelector('[data-pc-pb-add]');
    var addLabel = root.querySelector('[data-pc-pb-add-label]');
    var addPrice = root.querySelector('[data-pc-pb-add-price]');
    var status = root.querySelector('[data-pc-pb-status]');
    var whatsapp = root.querySelector('[data-pc-pb-whatsapp]');
    var shippingTitle = root.querySelector('[data-pc-pb-shipping-title]');
    var shippingText = root.querySelector('[data-pc-pb-shipping-text]');
    var offers = Array.from(root.querySelectorAll('[data-pc-pb-offer]'));
    var sticky = root.querySelector('[data-pc-pb-sticky]');
    var stickyAdd = root.querySelector('[data-pc-pb-sticky-add]');
    var stickyPrice = root.querySelector('[data-pc-pb-sticky-price]');
    var stickyOffer = root.querySelector('[data-pc-pb-sticky-offer]');
    var buyZone = root.querySelector('[data-pc-pb-buy-zone]');
    var zoomModal = root.querySelector('[data-pc-pb-zoom-modal]');
    var zoomImage = root.querySelector('[data-pc-pb-zoom-image]');

    function showSlide(index) {
      if (!slides.length) return;
      var next = ((Number(index) % slides.length) + slides.length) % slides.length;
      activeSlide = next;
      slides.forEach(function (slide, i) {
        var active = i === next;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) {
          slide.querySelectorAll('video').forEach(function (video) { try { video.pause(); } catch (error) {} });
        }
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === next;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (count) count.textContent = (next + 1) + ' / ' + slides.length;
      if (thumbs[next]) thumbs[next].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }

    function showMediaId(mediaId) {
      if (!mediaId) return;
      var target = slides.findIndex(function (slide) { return Number(slide.dataset.mediaId) === Number(mediaId); });
      if (target >= 0) showSlide(target);
    }

    function variantFromOptions() {
      return variants.find(function (variant) {
        if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) return false;
        return variant.options.every(function (value, index) { return String(value) === String(selectedOptions[index]); });
      }) || null;
    }

    function canBuyQuantity(variant, quantity) {
      if (!variant || !variant.available) return false;
      if (variant.inventoryManagement && String(variant.inventoryPolicy) !== 'continue') {
        return Number(variant.inventoryQuantity || 0) >= Number(quantity || 1);
      }
      return true;
    }

    function setStatus(message, type) {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', type === 'error');
      status.classList.toggle('is-success', type === 'success');
    }

    function parseCustomPriceCents(value) {
      var normalized = String(value || '').trim().replace(/[^0-9.,]/g, '').replace(',', '.');
      if (!normalized) return 0;
      var amount = Number(normalized);
      if (!Number.isFinite(amount) || amount <= 0) return 0;
      return Math.round(amount * 100);
    }

    function offerTotal(offer, quantity) {
      var customTotal = offer ? parseCustomPriceCents(offer.dataset.customPrice) : 0;
      if (customTotal > 0) return customTotal;
      return currentVariant ? Number(currentVariant.price || 0) * Math.max(1, Number(quantity || 1)) : 0;
    }

    function selectedOfferElement() {
      return offers.find(function (offer) { return String(offer.dataset.plan || '1') === String(selectedPlan); }) || null;
    }

    function compareTotalForOffer(quantity, total) {
      if (!currentVariant) return 0;
      var qty = Math.max(1, Number(quantity || 1));
      var regularTotal = Number(currentVariant.price || 0) * qty;
      var compareAtTotal = Number(currentVariant.compareAtPrice || 0) > Number(currentVariant.price || 0)
        ? Number(currentVariant.compareAtPrice || 0) * qty
        : 0;
      var compareTotal = Math.max(regularTotal, compareAtTotal);
      return compareTotal > Number(total || 0) ? compareTotal : 0;
    }

    function currentTotal() {
      return offerTotal(selectedOfferElement(), selectedQuantity);
    }

    function currentCompareTotal() {
      var total = currentTotal();
      return compareTotalForOffer(selectedQuantity, total);
    }

    function updateOfferCards() {
      offers.forEach(function (offer) {
        var quantity = Math.max(1, Number(offer.dataset.quantity || 1));
        var total = offerTotal(offer, quantity);
        var compareTotal = compareTotalForOffer(quantity, total);
        var totalNode = offer.querySelector('[data-pc-pb-offer-price]');
        var compareNode = offer.querySelector('[data-pc-pb-offer-compare]');
        if (totalNode) totalNode.textContent = money(total, config.currency);
        if (compareNode) compareNode.textContent = compareTotal > total ? money(compareTotal, config.currency) : '';
      });
    }

    function updateStock() {
      if (!stock || !stockText || !currentVariant) return;
      var threshold = Math.max(1, Number(stock.dataset.threshold || 20));
      var managed = Boolean(currentVariant.inventoryManagement);
      var quantity = Number(currentVariant.inventoryQuantity || 0);
      var shouldShow = managed && String(currentVariant.inventoryPolicy) !== 'continue' && quantity > 0 && quantity <= threshold;
      stock.classList.toggle('is-hidden', !shouldShow);
      if (shouldShow) {
        var template = stock.dataset.template || 'Only {count} left in stock';
        stockText.textContent = template.replace('{count}', quantity);
      }
    }

    function updateShipping() {
      var freeAt = Math.max(1, Number(config.freeDeliveryQuantity || 2));
      if (selectedQuantity >= freeAt) {
        if (shippingTitle) shippingTitle.textContent = 'FREE DELIVERY UNLOCKED';
        if (shippingText) shippingText.textContent = 'Your selected offer qualifies for free delivery across Lebanon.';
      } else {
        if (shippingTitle) shippingTitle.textContent = 'DELIVERY ACROSS LEBANON';
        if (shippingText) shippingText.textContent = money(config.deliveryFeeCents, config.currency) + ' delivery for Buy 1. Choose Buy 2 to unlock free delivery.';
      }
    }

    function updateWhatsapp() {
      if (!whatsapp || !config.whatsappNumber) return;
      var template = whatsapp.dataset.message || 'Hi ThePrimeCatch, I want to order {product}.';
      var message = template
        .replace('{product}', config.productTitle || 'ShowerDock')
        .replace('{quantity}', String(selectedQuantity))
        .replace('{offer}', 'Buy ' + selectedQuantity)
        .replace('{price}', money(currentTotal(), config.currency));
      if (discountCopied && timerActive && activeDiscountCode) {
        message += ' Discount code: ' + activeDiscountCode + '. Please apply it to this order.';
      }
      whatsapp.href = 'https://wa.me/' + config.whatsappNumber + '?text=' + encodeURIComponent(message);
    }

    function updatePurchaseState() {
      var total = currentTotal();
      var compareTotal = currentCompareTotal();
      var purchasable = canBuyQuantity(currentVariant, selectedQuantity);

      if (price) price.textContent = currentVariant ? money(currentVariant.price, config.currency) : '';
      if (compare) {
        var showCompare = currentVariant && Number(currentVariant.compareAtPrice || 0) > Number(currentVariant.price || 0);
        compare.classList.toggle('is-hidden', !showCompare);
        compare.textContent = showCompare ? money(currentVariant.compareAtPrice, config.currency) : '';
      }
      if (sale) {
        var showSale = currentVariant && Number(currentVariant.compareAtPrice || 0) > Number(currentVariant.price || 0);
        sale.classList.toggle('is-hidden', !showSale);
      }
      if (formVariant) formVariant.value = currentVariant ? currentVariant.id : '';
      if (formQuantity) formQuantity.value = selectedQuantity;
      if (add) add.disabled = !purchasable;
      if (stickyAdd) stickyAdd.disabled = !purchasable;
      if (addPrice) addPrice.textContent = money(total, config.currency);
      if (stickyPrice) stickyPrice.textContent = money(total, config.currency);
      if (stickyOffer) stickyOffer.textContent = 'Buy ' + selectedQuantity;
      if (addLabel) {
        var baseLabel = add ? (add.dataset.label || 'ADD TO CART') : 'ADD TO CART';
        if (!currentVariant || !currentVariant.available) addLabel.textContent = 'SOLD OUT';
        else if (!purchasable) addLabel.textContent = 'NOT ENOUGH STOCK';
        else addLabel.textContent = baseLabel;
      }
      updateOfferCards();
      updateStock();
      updateShipping();
      updateWhatsapp();
      if (compareTotal > total) {
        root.dataset.pcPbSavingsCents = String(compareTotal - total);
      } else {
        root.dataset.pcPbSavingsCents = '0';
      }
    }

    function selectOffer(offer) {
      if (!offer) return;
      selectedPlan = String(offer.dataset.plan || '1');
      selectedQuantity = Math.max(1, Number(offer.dataset.quantity || 1));
      offers.forEach(function (item) {
        var active = item === offer;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      setStatus('', '');
      updatePurchaseState();
    }

    function updateVariantButtons() {
      root.querySelectorAll('[data-pc-pb-option-value]').forEach(function (button) {
        var index = Number(button.dataset.optionIndex || 0);
        var active = String(selectedOptions[index]) === String(button.dataset.value || '');
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function selectVariantOption(button) {
      var index = Number(button.dataset.optionIndex || 0);
      selectedOptions[index] = String(button.dataset.value || '');
      currentVariant = variantFromOptions();
      updateVariantButtons();
      if (currentVariant && currentVariant.featuredMediaId) showMediaId(currentVariant.featuredMediaId);
      updatePurchaseState();
      if (currentVariant && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    async function addToCart() {
      if (!currentVariant || !canBuyQuantity(currentVariant, selectedQuantity)) {
        setStatus('This offer is not available with the current stock.', 'error');
        return;
      }

      if (add) add.disabled = true;
      if (stickyAdd) stickyAdd.disabled = true;
      setStatus('Adding to cart...', '');

      var properties = { '_ThePrimeCatch offer': 'Buy ' + selectedQuantity };

      try {
        if (window.PrimeCatchCart && typeof window.PrimeCatchCart.add === 'function') {
          await window.PrimeCatchCart.add(currentVariant.id, selectedQuantity, properties);
        } else {
          var response = await fetch((config.routesRoot || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: selectedQuantity, properties: properties }] })
          });
          if (!response.ok) throw new Error('Unable to add this offer to cart.');
          await response.json();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
        setStatus('Added to cart.', 'success');
      } catch (error) {
        setStatus(error && error.message ? error.message : 'Unable to add this offer to cart.', 'error');
      } finally {
        updatePurchaseState();
      }
    }

    function initTimer() {
      var timer = root.querySelector('[data-pc-pb-timer]');
      if (!timer) return;
      var value = timer.querySelector('[data-pc-pb-timer-value]');
      var prefix = timer.querySelector('[data-pc-pb-timer-prefix]');
      var discountBlock = root.querySelector('[data-pc-pb-discount]');
      var discountButton = root.querySelector('[data-pc-pb-discount-copy]');
      var discountButtonLabel = root.querySelector('[data-pc-pb-discount-button-label]');
      var discountStatus = root.querySelector('[data-pc-pb-discount-status]');
      // Shared two-minute UI offer window. Actual code validity is controlled by Shopify.
      var duration = 120000;
      var storageKey = 'primecatch:reserved-discount:v1';
      activeDiscountCode = discountBlock ? String(discountBlock.dataset.code || '').trim() : '';
      var discountTitle = discountBlock ? String(discountBlock.dataset.title || 'YOUR DISCOUNT') : 'YOUR DISCOUNT';
      var sharedOffer = null;
      try {
        var savedOffer = window.sessionStorage.getItem(storageKey);
        if (savedOffer) sharedOffer = JSON.parse(savedOffer);
      } catch (error) { sharedOffer = window.PrimeCatchReservedDiscount || null; }
      if (!sharedOffer || sharedOffer.code !== activeDiscountCode || !Number.isFinite(Number(sharedOffer.endsAt))) {
        sharedOffer = { code: activeDiscountCode, title: discountTitle, endsAt: Date.now() + duration };
        if (activeDiscountCode) {
          try { window.sessionStorage.setItem(storageKey, JSON.stringify(sharedOffer)); } catch (error) {}
        }
      }
      window.PrimeCatchReservedDiscount = sharedOffer;
      if (activeDiscountCode) document.dispatchEvent(new CustomEvent('primecatch:discount-offer-changed', { detail: sharedOffer }));

      function copyText(text) {
        if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
        return new Promise(function (resolve, reject) {
          var textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          try {
            var copied = document.execCommand('copy');
            textarea.remove();
            if (copied) resolve();
            else reject(new Error('Copy failed'));
          } catch (error) {
            textarea.remove();
            reject(error);
          }
        });
      }

      function expireTimer() {
        timerActive = false;
        discountCopied = false;
        timer.classList.remove('is-urgent');
        if (prefix) prefix.textContent = timer.dataset.expired || 'Offer available while stock lasts';
        if (value) value.textContent = '0:00';
        if (discountBlock) discountBlock.hidden = true;
        updateWhatsapp();
      }

      function renderTimer() {
        var remaining = Math.max(0, Number(sharedOffer.endsAt) - Date.now());
        if (remaining <= 0) {
          expireTimer();
          return false;
        }

        timerActive = true;
        if (discountBlock) discountBlock.hidden = false;
        var totalSeconds = Math.ceil(remaining / 1000);
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        var urgent = totalSeconds <= 30;
        timer.classList.toggle('is-urgent', urgent);
        if (value) value.textContent = String(minutes) + ':' + String(seconds).padStart(2, '0');
        updateWhatsapp();
        return true;
      }

      if (discountButton && activeDiscountCode) {
        discountButton.addEventListener('click', async function () {
          if (!timerActive) return;
          try {
            await copyText(activeDiscountCode);
            discountCopied = true;
            discountButton.classList.add('is-copied');
            if (discountButtonLabel) discountButtonLabel.textContent = discountButton.dataset.copiedLabel || 'COPIED';
            if (discountStatus) discountStatus.textContent = 'Discount copied. It will also be included if you order through WhatsApp.';
            updateWhatsapp();
          } catch (error) {
            if (discountStatus) discountStatus.textContent = 'Unable to copy automatically. Please try again.';
          }
        }, { signal: signal });
      }

      if (!renderTimer()) return;
      var timerId = window.setInterval(function () {
        if (!renderTimer()) window.clearInterval(timerId);
      }, 250);
      signal.addEventListener('abort', function () { window.clearInterval(timerId); }, { once: true });
    }

    var buyZoneInView = true;
    function updateStickyVisibility() {
      if (!sticky) return;
      var drawerOpen = Boolean(document.querySelector('body.pc-panel-open, .pc-header.is-panel-open, .pc-cart-drawer.is-active, .pc-menu-drawer.is-active, .pc-search.is-active'));
      var shouldShow = !buyZoneInView && !drawerOpen;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function initAccordions() {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      root.querySelectorAll('[data-pc-pb-accordion]').forEach(function (details) {
        var summary = details.querySelector('summary');
        var panel = details.querySelector('[data-pc-pb-accordion-panel]');
        if (!summary || !panel) return;

        panel.style.height = details.open ? 'auto' : '0px';
        panel.style.opacity = details.open ? '1' : '0';

        summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (details.dataset.animating === 'true') return;

          if (reducedMotion.matches) {
            details.open = !details.open;
            panel.style.height = details.open ? 'auto' : '0px';
            panel.style.opacity = details.open ? '1' : '0';
            return;
          }

          details.dataset.animating = 'true';

          if (details.open) {
            panel.style.height = panel.scrollHeight + 'px';
            panel.style.opacity = '1';
            requestAnimationFrame(function () {
              panel.style.height = '0px';
              panel.style.opacity = '0';
            });

            var closeEnd = function (transitionEvent) {
              if (transitionEvent.propertyName !== 'height') return;
              details.open = false;
              details.dataset.animating = 'false';
              panel.removeEventListener('transitionend', closeEnd);
            };
            panel.addEventListener('transitionend', closeEnd);
          } else {
            details.open = true;
            panel.style.height = '0px';
            panel.style.opacity = '0';
            var targetHeight = panel.scrollHeight;
            requestAnimationFrame(function () {
              panel.style.height = targetHeight + 'px';
              panel.style.opacity = '1';
            });

            var openEnd = function (transitionEvent) {
              if (transitionEvent.propertyName !== 'height') return;
              panel.style.height = 'auto';
              details.dataset.animating = 'false';
              panel.removeEventListener('transitionend', openEnd);
            };
            panel.addEventListener('transitionend', openEnd);
          }
        }, { signal: signal });
      });
    }

    function initReviewCarousels() {
      root.querySelectorAll('[data-pc-pb-reviews]').forEach(function (carousel) {
        var track = carousel.querySelector('[data-pc-pb-review-track]');
        var cards = Array.from(carousel.querySelectorAll('[data-pc-pb-review-card]'));
        var prev = carousel.querySelector('[data-pc-pb-review-prev]');
        var next = carousel.querySelector('[data-pc-pb-review-next]');
        var dotsWrap = carousel.querySelector('[data-pc-pb-review-dots]');
        if (!track || !cards.length) return;

        var activeIndex = 0;
        var rafId = 0;
        var dots = [];

        function cardLeft(index) {
          var card = cards[index];
          if (!card) return 0;
          return card.offsetLeft - track.offsetLeft;
        }

        function goTo(index) {
          var nextIndex = Math.max(0, Math.min(cards.length - 1, Number(index) || 0));
          activeIndex = nextIndex;
          track.scrollTo({ left: cardLeft(nextIndex), behavior: 'smooth' });
          updateDots();
        }

        function updateDots() {
          dots.forEach(function (dot, index) {
            var active = index === activeIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }

        function syncIndex() {
          if (!cards.length) return;
          var currentLeft = track.scrollLeft;
          var nearest = 0;
          var nearestDistance = Infinity;
          cards.forEach(function (card, index) {
            var distance = Math.abs((card.offsetLeft - track.offsetLeft) - currentLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearest = index;
            }
          });
          activeIndex = nearest;
          updateDots();
        }

        if (dotsWrap && cards.length > 1) {
          cards.forEach(function (card, index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
            dot.addEventListener('click', function () { goTo(index); }, { signal: signal });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          });
          updateDots();
        }

        if (prev) prev.addEventListener('click', function () { goTo(activeIndex - 1); }, { signal: signal });
        if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); }, { signal: signal });

        track.addEventListener('scroll', function () {
          if (rafId) cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(syncIndex);
        }, { signal: signal, passive: true });

        signal.addEventListener('abort', function () {
          if (rafId) cancelAnimationFrame(rafId);
        }, { once: true });
      });
    }

    initAccordions();
    initReviewCarousels();

    var defaultOffer = root.querySelector('[data-pc-pb-offers]');
    var defaultPlan = defaultOffer ? String(defaultOffer.dataset.defaultPlan || '1') : '1';
    selectOffer(offers.find(function (offer) { return String(offer.dataset.plan) === defaultPlan; }) || offers[0]);
    updatePurchaseState();
    initTimer();

    root.querySelector('[data-pc-pb-prev]')?.addEventListener('click', function () { showSlide(activeSlide - 1); }, { signal: signal });
    root.querySelector('[data-pc-pb-next]')?.addEventListener('click', function () { showSlide(activeSlide + 1); }, { signal: signal });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showSlide(Number(thumb.dataset.index || 0)); }, { signal: signal }); });
    offers.forEach(function (offer) { offer.addEventListener('click', function () { selectOffer(offer); }, { signal: signal }); });
    root.querySelectorAll('[data-pc-pb-option-value]').forEach(function (button) { button.addEventListener('click', function () { selectVariantOption(button); }, { signal: signal }); });

    if (slidesWrap) {
      var startX = null;
      slidesWrap.addEventListener('pointerdown', function (event) { startX = event.clientX; }, { signal: signal });
      slidesWrap.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        showSlide(activeSlide + (delta < 0 ? 1 : -1));
      }, { signal: signal });
      slidesWrap.addEventListener('pointercancel', function () { startX = null; }, { signal: signal });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart();
      }, { signal: signal });
    }

    if (stickyAdd) stickyAdd.addEventListener('click', addToCart, { signal: signal });

    root.querySelectorAll('[data-pc-pb-zoom]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (!zoomModal || !zoomImage) return;
        zoomImage.src = trigger.dataset.zoomSrc || '';
        zoomModal.classList.add('is-active');
        zoomModal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }, { signal: signal });
    });

    function closeZoom() {
      if (!zoomModal) return;
      zoomModal.classList.remove('is-active');
      zoomModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    root.querySelector('[data-pc-pb-zoom-close]')?.addEventListener('click', closeZoom, { signal: signal });
    if (zoomModal) zoomModal.addEventListener('click', function (event) { if (event.target === zoomModal) closeZoom(); }, { signal: signal });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeZoom(); }, { signal: signal });

    if (sticky && buyZone && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        buyZoneInView = entries[0] ? entries[0].isIntersecting : true;
        updateStickyVisibility();
      }, { threshold: .15 });
      observer.observe(buyZone);
      signal.addEventListener('abort', function () { observer.disconnect(); }, { once: true });
    }

    if (sticky && 'MutationObserver' in window) {
      // Observe only the panel nodes and body class, never the entire DOM subtree.
      var panelNodes = document.querySelectorAll('.pc-header, .pc-cart-drawer, .pc-menu-drawer, .pc-search');
      var mutationObserver = new MutationObserver(updateStickyVisibility);
      panelNodes.forEach(function (panel) {
        mutationObserver.observe(panel, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      });
      mutationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      signal.addEventListener('abort', function () { mutationObserver.disconnect(); }, { once: true });
    }
    updateStickyVisibility();
  }

  function initAll(scope) {
    var parent = scope || document;
    if (parent.matches && parent.matches('[data-pc-product-builder]')) initBuilder(parent);
    if (parent.querySelectorAll) parent.querySelectorAll('[data-pc-product-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  if (!window.__pcProductBuilderLifecycleBound) {
    window.__pcProductBuilderLifecycleBound = true;
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target && event.target.querySelector ? event.target.querySelector('[data-pc-product-builder]') : null;
      if (!root && event.target && event.target.matches && event.target.matches('[data-pc-product-builder]')) root = event.target;
      if (root && root._pcPbController) root._pcPbController.abort();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
